import _ from 'lodash';
import React, { Component } from "react";
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import Pagination from "../Shared/pagination";
import ContactsService from '../utils/ContactsService';
import ContactsTable from "./ContactsTable";

class ContactsListView extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      filter: { view: "list", assigned: "" },
      items: [], initialItems: [],
      textFilter: '',
      flags: [],
      selectedItems: [],
      showMessageModal: false,
      currentPage: 1,
      per: 100
    };
    this.debouncedFetchItems = _.debounce(() => this.fetchItems(), 300)

  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, this.fetchItems)
  }

  onPageChange = (currentPage) => {
    this.setState({ currentPage: currentPage }, () => this.fetchItems());
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view, messagingConfig: this.props.messagingConfig, currentPage: 1 }, this.fetchItems)
    }
  }

  fetchItems() {
    ContactsService.index({ view: this.state.view, text_filter: this.state.textFilter, page: this.state.currentPage, per: this.state.per }).then(response => {
      this.setState({ loadingInProgress: false, items: response.results, totalPages: Math.ceil(response.total_count / this.state.per) })
    })
  }

  handleFlagChange = (flags) => {
    this.setState({ flags: flags })
  }

  itemSelectAllChanged = (selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      item.isSelected = selected
      return item
    })
    this.setState({ items: items })
  }

  itemSelectStateChanged = (id, selected) => {
    var items = JSON.parse(JSON.stringify(this.state.items)).map((item) => {
      if (item.id === id) item.isSelected = selected
      return item
    })

    this.setState({ items: items })
  }

  selectedItems = () => {
    return this.state.items.filter((item) => item.isSelected)
  }

  groupActionsEnabled = () => {
    return this.selectedItems().length > 0
  }

  closeMessageModal = () => {
    this.setState({ showMessageModal: false, modalMessageType: null, modalMessageIndex: null, modalMessageItem: null });
  }

  showMessageModal = (type, index, item) => {
    this.setState({ showMessageModal: true, modalMessageType: type, modalMessageIndex: index, modalMessageItem: item });
  }

  sendMessage = (testMode) => {
    const params = { deal_ids: this.selectedItems().map((item) => item.id), message_type: this.state.modalMessageType, message_item: this.state.modalMessageItem, test_mode: testMode }
    ContactsService.sendGroupMessage(params)
      .then((response) => { Alert.success('Sent message OK') })
      .catch((response) => { Alert.error(`<h1>Error sending message</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 }) })
  }

  handleTextFilterChange = (event) => {
    let value = event.target.value;
    this.setState({ textFilter: value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }, this.debouncedFetchItems)
  }

  handleContactUpdated = (contact) => {
    const items = this.state.items.map((item) => item.id === contact.id ? Object.assign(item, contact) : item)
    this.setState({ items: items })
  }
  render() {

    const { loadingInProgress } = this.state;

    return (

<LoadingIndicator loadingInProgress={loadingInProgress}>
        <div className='row'>
          <div className="col-sm-3">
            <div style={{ margin: '0 0 10px 0' }}>
              <input type="text" placeholder="Search" className='form-control input-sm' value={this.state.textFilter} onChange={this.handleTextFilterChange} />
            </div>
          </div>


          <div className="col-sm-3">
          {this.state.totalPages >= 2 ? (<div className='pull-right'>
            <Pagination
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onChange={this.onPageChange}
                />
            </div>) : <span></span>}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
                <div>
                  {this.state.items.length === 0
                    ? <h5>No matching records</h5>
                    : <ContactsTable
                      items={this.state.items}
                      itemSelectStateChanged={this.itemSelectStateChanged}
                      itemSelectAllChanged={this.itemSelectAllChanged}
                      handleContactUpdated={this.handleContactUpdated}
                    />
                  }

                </div>
          </div>
        </div>

      </LoadingIndicator>
    );
  }
}
export default ContactsListView